import { decode } from '../../../utils/base64Utils';
import { getBasketItems } from './basket-items';

/**
 * Extracts and transforms user related cookie values
 */
type CreateUserProfileProps = {
  cached_basket?: string;
  userGreeting?: string;
  shopperId?: string;
  signedIn?: boolean;
  cookieUsageAcknowledged?: boolean;
  'mt.v'?: string;
};

export const createUserProfile = ({
  cached_basket: cachedBasket = '',
  userGreeting,
  shopperId,
  signedIn,
  'mt.v': monetateId,
}: CreateUserProfileProps = {}): UserProfile => ({
  user: {
    basket: {
      items: getBasketItems(cachedBasket),
    },
    greeting: decode(userGreeting),
    signedIn: !!signedIn,
    shopperId,
    monetateId,
  },
});
